var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c("image-uploader", {
        attrs: {
          label: "Image thumbnail",
          accountID: _vm.thumbnailPath,
          isVideoThumbnail: true,
          "form-submitted": false,
          validations: {}
        },
        on: { uploadSuccess: _vm.onUploadSuccess }
      }),
      _c("div", { staticClass: "imageContainer" }, [
        _vm.completeURL !== ""
          ? _c("img", { attrs: { src: _vm.completeURL, alt: "hero image" } })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10c79870", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10c79870","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/mediaItem/ThumbnailUploader.vue
// module id = 958
// module chunks = 0